import React from "react";
import Chip from "@mui/material/Chip";

const statusMap = {
  draft: { label: "Borrador", color: "default" },
  process: { label: "Analizado", color: "info" },
  sent_to_rector: { label: "Enviado (al rector)", color: "warning" },
  approved_by_rector: { label: "Aprobado (por rector)", color: "success" },
  rejected_by_rector: { label: "Rechazado (por rector)", color: "error" },
  sent_to_applicant: { label: "Enviado (al solicitante)", color: "warning" },
  approved_by_applicant: {
    label: "Aprobado (por solicitante)",
    color: "success",
  },
  rejected_by_applicant: {
    label: "Rechazado (por solicitante)",
    color: "error",
  },
  wait_to_sign: { label: "Pendiente de firmas", color: "warning" },
  signed: { label: "Aprobado (firmados)", color: "success" },
  expired: {
    label: "Vencido",
    sx: { backgroundColor: "#212121", color: "#fff" },
  },
  next_to_expired: { label: "Por vencer", color: "warning" },
  finished: {
    label: "Terminado",
    sx: { backgroundColor: "#1b5e20", color: "#fff" },
  },
};

export default function AgreementStatus({ currentStatus }) {
  const status = statusMap[currentStatus];

  if (!status) return <Chip label="Ninguno" />;

  return <Chip label={status.label} color={status.color} sx={status.sx} />;
}
